<template>
  <div class="audit">
    <h4 class="title">精品课程免费听</h4>
    <van-tabs class="profession-tabs" v-model="professionId" type="card" color="#fe563e" animated>
      <template v-for="(item, index) in professionList">
        <van-tab :key="index" :name="item.id" :title="item.name" />
      </template>
    </van-tabs>
    <div class="course-tabs">
      <template v-for="(item, index) in courseList">
        <span
          :key="index"
          :class="item.id===courseId?'tab tab-active':'tab'"
          @click="courseId = item.id"
        >{{item.name}}</span>
      </template>
    </div>
    <div class="video-list">
      <div class="wrapper" v-if="videoList.length">
        <van-loading v-if="show" class="loading" />
        <template v-for="(item, index) in videoList">
          <van-cell
            :key="index"
            :title="item.name"
            :url="'/video/' + item.videoExcellentId"
            icon="play-circle-o"
            value="点击观看"
            value-class="play iconfont"
          />
        </template>
      </div>
    </div>
    <router-link
      v-if="videoList.length"
      :to="'/video/' + videoList[0].videoExcellentId"
      class="video-add"
    >点击观看更多</router-link>
  </div>
</template>

<script>
  import courseModel from 'models/course';
  import { professionList } from './config';

  export default {
    name: 'VideoAudit',
    data() {
      return {
        professionId: '', // 当前职业
        courseId: '', // 当前课程
        courseList: [],
        videoList: [], // 视频列表
        show: false, // 正在加载中
      };
    },
    watch: {
      professionId(val) {
        this.courseList = courseModel.getCourseListById(val);
        this.courseId = this.courseList[0].id;
      },
      courseId(val) {
        this.getVideoList(val);
      },
    },
    created() {
      this.professionList = professionList;
      this.professionId = this.professionList[0].id;
    },
    methods: {
      getVideoList(courseId) {
        this.show = true;
        this.axios
          .get(`https://cj.tibaitong.com/api/excellent/list/${courseId}`)
          .then((res) => {
            this.show = false;
            if (res.data.code === 200) {
              this.videoList = res.data.data.slice(0, 3);
            }
          });
      },
    },
  };
</script>

<style lang="scss" scoped>
@import "~assets/scss/mixins";

.audit {
  .title {
    font-size: 18px;
    font-weight: bold;
    text-align: center;
    line-height: 2.5;
    background-color: #fff;
    border-bottom: 1px solid #eee;
  }

  .course-tabs {
    display: flex;
    margin: 10px 0 5px;

    .tab {
      margin-left: 15px;
      padding: 0 10px;
      font-size: 12px;
      line-height: 2;
      background-color: #fff;
      border-radius: 10px;
    }

    .tab-active {
      color: $theme-color;
    }
  }

  .video-list {
    position: relative;
    margin: 10px 10px 0;

    .wrapper {
      width: 100%;
      background-color: #fff;
      border-radius: 5px 5px 0 0;
      @include flex-center(column);

      .loading {
        position: absolute;
      }

      .van-cell {
        width: 100%;
        background-color: transparent;

        /* 点击观看 */
        .play {
          font-size: 14px;
          color: $theme-color;

          &:before {
            margin-right: 5px;
            content: "\e602";
          }
        }
      }
    }
  }

  .video-add {
    display: block;
    margin: 0 10px;
    font-size: $font-size-l;
    letter-spacing: 1px;
    text-align: center;
    line-height: 40px;
    background-color: #efefef;
    border-radius: 0 0 5px 5px;
  }
}
</style>
